import React from 'react';
import ReactDom from 'react-dom';

class LeaveDetailModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleClick = this.handleClick.bind(this);
       
        this.state = {
            staffIds: [],
            warningMsg: "",
            staffId: "",
            clientHeight: 200
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {
        let clientHeight = ReactDom.findDOMNode(this.refs.modal).clientHeight;
        this.setState({
            clientHeight: clientHeight,
        });

    }
    
    handleClick(e) {
        this.props.shouldModalClose(false);
    }
    modalClose() {
        this.props.shouldModalClose(false);
    }
    
    renderDetail() {
        return this.props.detail.map((detail, index)=>{
            return (
                <li className={"pm-li-1 "+ (detail.status == 0 ? "":"lv-red")} key={index}>
                    {detail.leaveTxt}
                </li>
            );
        }); 
    }
    

    renderContent() {
        return (
            <div>
                <div className="divider"></div>
                <ul className="pm-ul" style={{height:(this.state.clientHeight-200)+"px",overflow:"auto"}}>
                    {this.renderDetail()}
                </ul>
            </div>
        )

    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="permission-modal" style={{ visibility: style.visibility }} ref="modal">
                    <div className="modal-header">
                        <h4 className="modal-title" >Leave Summary</h4>
                    </div>

                    <div className="modal-body" style={{ height: (this.state.clientHeight - 115) + "px" }}>
                        <div className="warning">{this.state.warningMsg}</div>
                        {this.renderContent()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-warning single-btn" onClick={this.handleClick}>Ok</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default LeaveDetailModal;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/leaveDetailModal.js